import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css } from 'styled-components';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

interface StyledContentContainerProps {
  isOnHomePage?: boolean;
}

// StyledContentContainer component
export const StyledContentContainer = styled.div<StyledContentContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  gap: var(--size-dual-nudge);
  margin: 0 auto;

  ${(props) =>
    props.isOnHomePage &&
    `
      /* Additional styles when isOnHomePage is true */
      background-color: #f0f0f0;
    `}
`;

// Active card styles
export const activeCardStyles = css`
  background: var(--c-white);
  box-shadow:
    0 2px 10px rgb(0 0 0 / 20%),
    0 16px 24px rgb(0 0 0 / 10%);
  transition: all 0.5s var(--animation-bezier);
`;

// StyledPostCardContainer component
interface StyledPostCardContainerProps {
  $type?: string;
}

export const StyledPostCardContainer = styled.a<StyledPostCardContainerProps>`
  background: var(--c-aef-white);
  border-radius: var(--radius-lg);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--size-1);
  width: 100%;
  text-decoration: none;
  border: 1px solid var(--c-grey-1);
  padding: ${(props) =>
    props.$type === `tomsBlog` ? `var(--size-1h)` : `var(--size-1)`};
  box-shadow:
    0 0 1px rgb(0 0 0 / 0%),
    0 0 1px rgb(0 0 0 / 0%);
  cursor: pointer;
  transition: all 0.5s var(--animation-bezier);

  &:hover,
  &:focus {
    ${activeCardStyles}
  }

  &:hover svg,
  &:focus svg {
    color: var(--c-yellow-1);
  }

  @media screen and (width <= 1000px) {
    flex-direction: column;
  }
`;

// StyledPostCardImg component
export const StyledPostCardImgWrapper = styled.div`
  border-radius: var(--radius-md);
  width: 200px;
  height: 134px;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`;

// StyledFontAwesomeIcon component
interface StyledFontAwesomeIconProps {
  icon: IconProp;
}

export const StyledFontAwesomeIcon = styled(
  FontAwesomeIcon,
)<StyledFontAwesomeIconProps>`
  color: var(--c-grey-3);
  font-size: var(--size-4);
  transition: all 0.5s var(--animation-bezier);
`;
